import { render } from "./PolicyRules.vue?vue&type=template&id=3e2aa6ac"
import script from "./PolicyRules.vue?vue&type=script&lang=js"
export * from "./PolicyRules.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__